export enum SettingsColorSchemes {
  default = 'default',
  blackOnYellow = 'black-on-yellow',
  whiteOnBlack = 'white-on-black',
}
